/*
  Carrosseis que rolam para o lado (estilo em assets/unend-rolagem.css):
  - Barra de progresso fina embaixo de cada carrossel, mostrando que tem mais conteudo para o lado e em que ponto
    da lista o cliente esta. Some quando tudo cabe na tela. No lugar dos pontinhos redondos do tema.
  - Setas que vao ate o fim: o tema desligava a seta quando faltavam menos de 100px para o fim, e o ultimo cartao
    ficava cortado (ex.: lojinhas da home no computador). Aqui a seta so desliga quando a lista chegou mesmo ao fim
    (ou ao inicio, para a seta da esquerda).
  Ficam de fora a galeria de fotos do produto e os carrosseis de janelas e gavetas.
*/
(() => {
  const SELETOR = 'scroll-carousel, .unend-cur__cards, .unend-vender__steps';
  const FORA = '.product-gallery__carousel';
  const DENTRO_DE_FORA = '.product-gallery, x-drawer, x-modal, quick-buy-modal, cart-drawer';
  const FOLGA = 4;
  const preparadas = new WeakSet();

  const botao = (lista, tipo) => {
    if (!lista.id) return null;
    return document.querySelector(`carousel-${tipo}-button[aria-controls="${lista.id}"] button`);
  };

  const preparar = (lista) => {
    if (preparadas.has(lista) || lista.matches(FORA) || lista.closest(DENTRO_DE_FORA)) return;
    preparadas.add(lista);

    const barra = document.createElement('div');
    barra.className = 'unend-progresso';
    barra.setAttribute('aria-hidden', 'true');
    barra.hidden = true;
    const polegar = document.createElement('span');
    polegar.className = 'unend-progresso__barra';
    barra.append(polegar);

    /* Logo depois da lista: dentro do envoltorio das setas, a seta da direita precisa continuar sendo o ultimo item
       (o tema posiciona as setas por :first-child e :last-child) */
    lista.after(barra);
    const envoltorio = lista.parentElement;
    if (envoltorio && envoltorio.classList.contains('floating-controls-container')) {
      envoltorio.classList.add('unend-com-progresso');
    }

    if (lista.id) {
      document.querySelectorAll(`carousel-navigation.page-dots[aria-controls="${lista.id}"]`).forEach((pontos) => {
        pontos.classList.add('unend-sem-pontos');
      });
    }

    let agendado = false;
    const atualizar = () => {
      agendado = false;
      const total = lista.scrollWidth;
      const visivel = lista.clientWidth;
      const sobra = total - visivel;
      const anterior = botao(lista, 'prev');
      const proximo = botao(lista, 'next');

      if (!visivel || sobra <= 2) {
        barra.hidden = true;
        return;
      }

      const posicao = Math.min(Math.abs(lista.scrollLeft), sobra);
      barra.hidden = false;
      barra.style.setProperty('--unend-progresso-tamanho', `${(visivel / total) * 100}%`);
      barra.style.setProperty('--unend-progresso-desloc', `${(posicao / visivel) * 100}%`);

      if (anterior) anterior.disabled = posicao <= FOLGA;
      if (proximo) proximo.disabled = sobra - posicao <= FOLGA;
    };

    const agendar = () => {
      if (agendado) return;
      agendado = true;
      requestAnimationFrame(atualizar);
    };

    lista.addEventListener('scroll', agendar, { passive: true });
    lista.addEventListener('scrollend', agendar, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(agendar).observe(lista);
    agendar();
  };

  const varrer = (raiz) => {
    if (raiz.matches && raiz.matches(SELETOR)) preparar(raiz);
    raiz.querySelectorAll(SELETOR).forEach(preparar);
  };

  const iniciar = () => {
    varrer(document);
    new MutationObserver((mudancas) => {
      mudancas.forEach((mudanca) => {
        mudanca.addedNodes.forEach((no) => {
          if (no.nodeType === 1 && !no.classList.contains('unend-progresso')) varrer(no);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar, { once: true });
  } else {
    iniciar();
  }
})();
